import { Flex, Table, Typography } from "antd";
import type { ColumnType } from "antd/lib/table";
import { ImpressaoContainer, ImpressaoHeader } from "components/Impressao";
import { decimalFormater, numberToCurrency } from "std/format";
import { roundAbnt } from "std/math";
import type { TApiLancamentos } from ".";

const { Title } = Typography;

export const columns: ColumnType<TApiLancamentos>[] = [
	{
		dataIndex: "codigo",
		key: "codigo",
		title: "Código",
		align: "center",
	},
	{
		dataIndex: "data",
		key: "data",
		title: "Data",
	},
	{
		dataIndex: "entidade",
		key: "entidade",
		title: "Produtor",
	},
	{
		dataIndex: "transportador",
		key: "transportador",
		title: "Transportador",
	},
	{
		dataIndex: "descricao",
		key: "descricao",
		title: "Descrição",
		render: (value, row) => {
			if (!row?.fornecedorConveniado) {
				return value;
			}

			return `${value} - Fornecedor: ${row.fornecedorConveniado}`;
		},
	},
	{
		dataIndex: "quantidade",
		key: "quantidade",
		title: "Quantidade",
		align: "right",
	},
	{
		dataIndex: "valorUnitario",
		key: "valorUnitario",
		title: "Vlr. Unit.",
		align: "right",
		render: (value, row) => {
			if (row?.tipo === "crioscopia") {
				return value || 0;
			}

			return numberToCurrency(value || 0);
		},
	},
	{
		dataIndex: "total",
		key: "total",
		title: "Total",
		align: "right",
		render: (value, row) => {
			if (row?.tipo === "crioscopia") {
				return value || 0;
			}

			return numberToCurrency(value || 0);
		},
	},
];

export function TableRelLancamentos({ data, title }: { data: TApiLancamentos[] | undefined; title: string }) {
	const totalQuantidade = roundAbnt(
		(data || []).reduce((acc, cur) => acc + cur.quantidade, 0),
		4,
	);

	const totalGeral = roundAbnt(
		(data || []).reduce((acc, cur) => acc + (cur.tipo !== "crioscopia" ? cur.total : 0), 0),
		4,
	);

	return (
		<ImpressaoContainer className="w-full mt-3" title={title}>
			<ImpressaoHeader title={title} />

			<Table
				rowKey="codigo"
				columns={columns}
				dataSource={data}
				pagination={false}
				size="small"
				rowClassName="zebra"
				summary={(rows) => (
					<Table.Summary.Row>
						<Table.Summary.Cell index={0} align="left" colSpan={3}>
							<div style={{ display: "flex" }}>
								<Flex vertical={true}>
									<Title level={5}>Registros:</Title>
									<Title level={5} style={{ margin: "0px", textAlign: "right" }}>
										{rows?.length || 0}
									</Title>
								</Flex>
							</div>
						</Table.Summary.Cell>

						<Table.Summary.Cell index={1} align="right" colSpan={3}>
							<Flex vertical={true}>
								<Title level={5} style={{ margin: "0px" }}>
									Quantidade:
								</Title>
								<Title level={5} style={{ margin: "0px" }}>
									{decimalFormater(totalQuantidade)}
								</Title>
							</Flex>
						</Table.Summary.Cell>

						<Table.Summary.Cell index={1} align="right" colSpan={2}>
							<Flex vertical={true}>
								<Title level={5} style={{ margin: "0px" }}>
									Total:
								</Title>
								<Title level={5} style={{ margin: "0px" }}>
									{numberToCurrency(totalGeral)}
								</Title>
							</Flex>
						</Table.Summary.Cell>
					</Table.Summary.Row>
				)}
			/>
		</ImpressaoContainer>
	);
}
